(function (module) {

    module.service('forecastMLModelUpdateService', [
        function(this: $TSFixMe) {
            var service = this;

            service.updateMlModelFitDone = (modelId: $TSFixMe, forecastData: $TSFixMe, forecastMetadata: $TSFixMe) => {
                const parts = modelId.split('_');
                const forecastUId = parts[0];
                const period = parts[1];

                //check if this is notification is for this forecast
                if (forecastMetadata.uId.toUpperCase() != forecastUId.toUpperCase()) {
                    return;
                }

                const isSku = parts.length == 3;

                if (isSku == false) {
                    return setMlData(forecastData.market.forecast, modelId, period);
                } else {
                    const oracleIndex = parts[2];
                    
                    const sku = _.chain(forecastData.market.brands).pluck('skus').flatten().find((s: $TSFixMe) => s.oracleIndex == oracleIndex).value();
                    if (sku) {
                        return setMlData(sku.forecast, modelId, period);
                    }
                }
            }

            service.updateRollingForecastMlModelFitDone = (modelId: $TSFixMe, rollingForecastData: $TSFixMe, rollingForecastMetadata: $TSFixMe) => {
                const parts = modelId.split('_');
                const rollingForecastUId = parts[0];
                const period = parts[1];

                if (rollingForecastMetadata.uId != rollingForecastUId) {
                    return;
                }

                return setMlData(rollingForecastData.forecast, modelId, period);
            }

            function setMlData(forecast: $TSFixMe, modelId: $TSFixMe, period: $TSFixMe) {

                if (!angular.isArray(forecast.machineLearningData)) {
                    forecast.machineLearningData = [
                        {
                            modelId,
                            monthNumberForAverage: period,
                            calculationIsReady: true
                        }]
                    return true;
                } else {
                    
                    var mlData = _.find(forecast.machineLearningData, (ml: $TSFixMe) => ml.monthNumberForAverage == period);
                    if (mlData) {
                        const wasNotReady = !mlData.calculationIsReady;
                        mlData.calculationIsReady = true;
                        return wasNotReady;
                    } else {
                        forecast.machineLearningData.push
                            ({
                                modelId,
                                monthNumberForAverage: period,
                                calculationIsReady: true
                            });

                        return true;
                    }
                }
            }


            service.areAllMlModelReady = (forecast: $TSFixMe) => {
                if (!forecast) {
                    return false;
                }
                
                const isMarekModelReady = _.every(forecast.market.forecast.machineLearningData, (ml: $TSFixMe) => ml.calculationIsReady);

                if (forecast.parameters.forecastMethod.methodId === 'sku') {
                    
                    const areAllSkuReady = _.chain(forecast.market.brands).pluck('skus').flatten().pluck('forecast').pluck('machineLearningData').flatten().every((ml: $TSFixMe) => ml.calculationIsReady).value();
                    return areAllSkuReady && isMarekModelReady;
                } else {
                    return isMarekModelReady;
                }
            }

            service.areAllMlModelReadyInRollingForecast = (forecast: $TSFixMe) => {
                if (!forecast) {
                    return false;
                }
                
                return _.every(forecast.forecast.machineLearningData, (ml: $TSFixMe) => ml.calculationIsReady);

            }

            service.isMarketModel = (modelId: $TSFixMe) => {
                return modelId.split('_').length == 2;
            }

            service.getForecastIUdFromModelId = (modelId: $TSFixMe) => modelId.split('_')[0];
        }]);


})(angular.module('topline.services'));